<template>
    <div class="classification">
        <el-form>
            <div class="head">
                <el-row>
                    <el-col :span="24">
                        <Tabs :tabsList="tabsList" :activeName.sync="activeName" @tab-click="handleChange" />
                    </el-col>
                    <div class="back-btn">
                        <el-button size="small" @click="back">返回</el-button>
                       </div>
                </el-row>
            </div>
        </el-form>
        <CommodityOpsList pageSoucre="shopLookByAdmin" v-if="activeName == 'goodList'" ref="commodityOpsListRef"/>
        <ReconciliationForOps v-else-if="activeName == 'moneyCheck'" ref="reconciliationForOpsRef"/>
    </div>
</template>
<script>
import Tabs from '@/components/Tabs'
import CommodityOpsList from '../../commodityOpsList/index.vue'
import ReconciliationForOps from "./componnet/reconciliationForOps.vue";
export default {
    components: { Tabs ,CommodityOpsList,ReconciliationForOps}, 
    data() {
        return {
            tabsList: [ // tabs 传的值
                {
                    name: 'goodList',
                    label: '商品列表',
                    value: 0,
                }, 
                {
                    name: 'moneyCheck',
                    label: '对账单',
                    value: 0,
                }, 
            ],
            activeName: 'goodList', 
        }
    },
    created(){
        
    },
    methods: {
        //切换tabs按钮
        handleChange(e) {
            if (e == 'goodsList') {
                this.$nextTick(()=>{
                    this.$refs['getTableList'].getTableList(1)
                })
            }else if(e == 'moneyCheck'){
                if(this.$route.query.shopId){
                    this.$nextTick(()=>{
                        this.$refs['reconciliationForOpsRef'].getList(this.$route.query.shopId)
                    })
                }
            }
        },
        back() {
            this.$router.back(-1)
        }
    }
}
</script>
<style lang="scss" scoped>
.head {
    margin: 0 20px;
}
.back-btn {
    position: absolute;
    right: 0;
    top: 10px;
}
</style>